module.exports = __webpack_public_path__ + "static/crystal-palace-mobile-044d620eea7a3ce2d157e1134a34614d.jpg";